<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1 style="display:inline-block">Scenarios in Firebase Database</h1>
    <button class="btn btn-primary" (click)="getData()" style="margin-left:50px;">Get Data</button>
    <button class="btn btn-primary" (click)="showModalNewScenario = true" style="margin-left:50px;">New Scenario</button>
    <br><br>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Key</th>
                <th>Property</th>
                <th>DisplayName</th>
                <th>Description</th>
                <th>World</th>
                <th>Lessonplan</th>
                <th>Players</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let obj of scenarios">
                <td class="link" (click)="gotoScenarioEdit(obj)">{{obj.key}}</td>
                <td class="link" (click)="selectScenario(obj)">{{obj.property}}</td>
                <td>{{obj.displayName}}</td>
                <td>{{obj.description}}</td>
                <td>{{obj.world}}</td>
                <td>{{obj.lessonplan}}</td>
                <td>{{this.getKeys(obj.players)?.length}}</td>

            </tr>
        </tbody>
    </table>

</div>
<!-- Modal ------------------------------------------------------------------------------>
<div *ngIf="showModal" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>Scenario {{scenario.property}}</h5>
        <div class="row">
            <div class="col-md-6">
                <sa-input-text [(text)]="scenario.displayName" [title]="'Display Name' "></sa-input-text>
                <br>
                <sa-input-text [(text)]="scenario.description" [title]="'Description' "></sa-input-text>
                <br>
                <sa-select [(Id)]="worldkey" [title]="'Worlds'" [options]="worldskeys"></sa-select>
                <br>
                <sa-select [(Id)]="lessonplankey" [title]="'Lesson Plans'" [options]="lessonplanskeys"></sa-select>
                <br>
                <button class="btn btn-primary" (click)="updateScenario()">Update</button>
            </div>
            <div class="col-md-6">
                <h3>Rename Scenario</h3>
                <sa-input-text [(text)]="newScenarioName" [title]="'New Name' "></sa-input-text>
                <button class="btn btn-primary" (click)="renameScenario()">Rename</button>
             
            </div>
        </div>
        <br>
        <button class="btn btn-primary" style="float:right" (click)="showModal = false">Close Modal</button>

        <hr><br>
        <h5>Players</h5>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Timestamp</th>
                    <th>Timelapse</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let player of scenario.players  | keyvalue">
                    <td>{{player.key}}</td>
                    <td>{{toAny(player.value).timestamp}}</td>
                    <td>{{toAny(player.value).datetime}}</td>
                    <td><button class="btn btn-warning" (click)="deletePlayer(player.key)">Delete</button></td>
                </tr>
            </tbody>
        </table>   
    </div>
</div>
<!-- Modal New Scenario ------------------------------------------------------------------------------>
<div *ngIf="showModalNewScenario" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>New Scenario </h5>
        <div class="row">
            <div class="col-md-6">
                <sa-input-text [(text)]="newScenarioName" [title]="'New Scenario Name' "></sa-input-text>

                <button class="btn btn-primary" (click)="newScenarioModal()">Update</button>
            </div>
        </div>
        <br>
        <button class="btn btn-primary" style="float:right" (click)="showModalNewScenario = false">Close Modal</button>
    </div>
</div>
<!-- {{scenario | json}} -->
